import { ContactProps } from "../serviceDetailModal/Decription.Modal.props";
import {
	DesContent,
	Div
} from "../serviceDetailModal/Description.styled";

const MemberBenefitModal = ({
	bodyContent,
	data,
	industyData,
}: ContactProps) => {
	return (
		<Div className="des-container">
			{data && (
				<>
					<DesContent className="description">
						<DesContent>{bodyContent}</DesContent>
					</DesContent>
				</>
			)}
		</Div>
	);
};

export default MemberBenefitModal;
